import {Component, ViewChild, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'full-calendar',
    templateUrl: 'fullcalendar.template.html',
    exportAs: 'full-calendar'
})
export class FullCalendarComponent {
    @Input('eventData') public eventData;
    @ViewChild('scheduleCalendar') public scheduleCalendar;
    @Output() onClickEvent: EventEmitter<any> = new EventEmitter<any>();

    private static _instance: FullCalendarComponent;

    public calendarOptions: any = {
        height: 'auto',
        fixedWeekCount : false,
        editable: false,
        eventLimit: false,
        timeFormat:'H(:mm)T',
        eventClick: function(calEvent) {
            if(calEvent.id){
                FullCalendarComponent.getInstance().updateSchedule(calEvent.id);
            }
        },
        events: []
    };
    constructor() {
        FullCalendarComponent._instance = this;
    }

    public static getInstance(): FullCalendarComponent {
        return FullCalendarComponent._instance;
    }

    public updateEvents(data){
        this.calendarOptions.events = data;
        this.scheduleCalendar.fullCalendar('removeEvents');
        this.scheduleCalendar.fullCalendar('addEventSource', this.calendarOptions.events);
    }

    public updateSchedule(entityId: number){
        this.onClickEvent.emit(entityId);
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/fullcalendar/fullcalendar.component.ts